import React from 'react';
import Style from '../Styles/PaymentMethodsComponentStyle';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';

export default function PaymentMethodsComponent(props) {
  const classes = Style();
    const setPaymentMethod = (e) => {
        componentMethods.setManagerState({paymentMethod: e.target.value})
    }
    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

  return (
    <Grid container spacing={3}>
        <Grid item xs={12} lg={12} md={112}>
            <FormControl component="fieldset" style={classes.formControl}>
                <RadioGroup aria-label="paymentMethod" name="paymentMethod" value={componentMethods.getManagerState().paymentMethod} onChange={setPaymentMethod }>
                    <FormControlLabel value={componentConstants.language.PAYMENT_METHOD_RAMBURS_ON_DELIVERY} control={<Radio color="secondary" />} label={componentConstants.language.LANG_PAYMENT_METHOD_RAMBURS} />
                </RadioGroup>
            </FormControl>
        </Grid>
    </Grid>
  );
}